import CheckmarkIcon from './CheckmarkIcon';
export default CheckmarkIcon;
